module.exports = __webpack_public_path__ + "img/shape-7_blue-300.e38c5b3.png";